import { Injectable } from '@angular/core';
import { ErrorCode } from '../enums/error-code';

@Injectable({
  providedIn: 'root'
})
export class ErrorProviderService {

  errorCode: ErrorCode = ErrorCode.NONE;
  errorMessage: string  = '';
  errorDetails: string = '';
  showRetryButton: boolean = false;
  retryButtonText: string = '';
  retryButtonIcon: string = null;
  retryButtonType: 'ROUTERLINK' | 'URL' | null = null;
  retryButtonTarget: '_blank' | '_self' | null = null;

  constructor() { }

  resetError() {
    this.errorCode = ErrorCode.NONE;
    this.errorMessage = '';
    this.errorDetails = '';
    this.showRetryButton = false;
    this.retryButtonText = '';
    this.retryButtonIcon = null;
    this.retryButtonType = null;
    this.retryButtonTarget = null;
  }
}
